export const filtersOptions = {
  status(value) {
    switch (value) {
      case 'G':
      case 'F':
      case 'P':
        return 'Public';
      case 'H':
        return 'Hidden';
      case 'S':
        return 'Searchable';
      case 'N':
        return 'Hidden';
    }
  },
  statusClass(value) {
    switch (value) {
      case 'G':
      case 'F':
      case 'P':
        return 'public';
      case 'S':
        return 'searchable';
      case 'N':
      case 'H':
      default:
        return 'hiddenStatus';
    }
  },
};
